import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Droplets, Wrench, Leaf, FileText, ClipboardList } from "lucide-react";
export default function UnsereUmweltfreundlichenLeistungen() {
  const services = [{
    id: 1,
    title: "Flächenreinigung ohne chemische Zusätze",
    description: "Professionelle Reinigung von Terrassen, Einfahrten, Pflaster, Parkplätzen und Spielplätzen – nur mit Wasser, ohne Chemie.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/surface_cleaning_water_pressure.png",
    icon: Droplets
  }, {
    id: 2,
    title: "Hausmeistertätigkeiten",
    description: "Zuverlässige Hausmeisterservices im nicht handwerkspflichtigen Bereich für Privathaushalte und Unternehmen.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/property_maintenance_services.png",
    icon: Wrench
  }, {
    id: 3,
    title: "Gartenpflege",
    description: "Hecken- und Rasenschnitt, Strauchschnitt, Laubbeseitigung und saisonale Gartenpflege für gepflegte Außenanlagen.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/garden_maintenance_landscaping.png",
    icon: Leaf
  }, {
    id: 4,
    title: "Bürotätigkeiten",
    description: "Professionelle Unterstützung bei administrativen Aufgaben und Büroorganisation für effiziente Geschäftsabläufe.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/office_administrative_work.png",
    icon: FileText
  }, {
    id: 5,
    title: "Hilfeleistungen im Bereich Büroorganisation",
    description: "Hilfe bei der Strukturierung und Optimierung Ihrer Büroabläufe sowie bei organisatorischen Aufgaben.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/office_organization_assistance.png",
    icon: ClipboardList
  }];
  return <section className="bg-background py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Unsere offiziell angemeldeten Dienstleistungen
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Fünf Leistungsbereiche für Ihre Anforderungen – professionell, zuverlässig und kompetent ausgeführt.
          </p>
        </div>
      
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
    {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className="bg-muted-light border-border hover:shadow-medium" style={{
            animationDelay: `${i * 100}ms`
          }}>
                <div className="relative h-48 overflow-hidden">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-primary/10" />
                </div>

                <CardHeader className="pb-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
                      <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl">{service.title}</CardTitle>
                  </div>
                </CardHeader>

                <CardContent className="pb-6">
                  <CardDescription className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>

                <CardFooter>
                  <Link to="/KontaktPage" className="w-full">
                    <Button variant="outline" className="w-full border-primary/20 hover:bg-primary/5 hover:border-primary/40 transition-colors">
                      Mehr erfahren
                    </Button>
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>

        <div className="text-center mt-12">
          <Link to="/KontaktPage">
            <Button className="btn-primary px-8 py-4 text-base shadow-medium">
              Kostenloses Angebot anfordern
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}